// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.

export const PARENT_HEADER_HEIGHT = 60; // height of the group node title bar
export const PARENT_WIDTH = 260; // default width of a root group node
export const WIDTH_DECREMENT = 20; // width reduction per nesting level

export const CHILD_HEIGHT = 112.5; // default height of an equipment node
export const CHILD_WIDTH = 200; // default width of an equipment node
export const CHILD_SPACING = 16; // vertical gap between stacked children
export const CHILD_SPACING_H = 48; // horizontal gap between children in horizontal/grid layouts

export const GAP = 50; // base spacing unit used across layouts

export const HANDLE_HEIGHT = 24; // height of one input/output handle row
export const GROUP_NODE_HEIGHT = PARENT_HEADER_HEIGHT + HANDLE_HEIGHT; // collapsed group height
export const CANVAS_CELL_W = PARENT_WIDTH + GAP * 2; // canvas placement grid cell width
export const CANVAS_CELL_H = GROUP_NODE_HEIGHT + GAP * 2; // canvas placement grid cell height

export const LAYOUT_MODES = ['vertical', 'horizontal', 'grid']; // available child layout modes
export const LAYOUT_LABELS = { vertical: 'Vertical', horizontal: 'Horizontal', grid: 'Grid' };
export const DIRECTION_LABEL = { both: '↔', input: '←', output: '→' };
